import API from './API.js'
import axios from 'axios'

export default class Roles extends API {
  constructor() {
    super('roles')
  }
  async allPermission(params) {
    const response = await axios.get(`/roles/get-all-permission`, { params })
    return response.data
  }
  //
}
